import dialog from './dialog'

export default (data) => {
    if (data && data.instance) {
        let instance = dialog.open({
            componentOptions: {
                componentConstructor: data.instance,
                propsData: data.propsData
            }
        }, {
            props: {
                size: 'full-screen'
            },
            on: {
                'cancel': () => {
                    console.warn('cancel')
                },
                'confirm': () => {
                    instance.close()
                    console.warn('confirm')
                }
            }
        })
    }
}
